<template>
  <div :id="svId" :class="className" :style="styleObj" ref="svgaContainer"></div>
</template>
 
<script>
import SVGA from "svgaplayerweb";
let svgaId = 0;
 
export default {
  name: "Svgaplayer",
  props: {
    src: { type: String, required: true }, // SVGA资源路径
    className: String,                    // 容器类名
    loops: { type: Number, default: Infinity }, // 循环次数，默认无限循环
    onFrame: Function,                    // 每帧回调
    styleObj: Object,                     // 容器样式
    mode: { type: String, default: "AspectFit" }, // 缩放模式
    onlyTag: String                       // 唯一标识
  },
  data() {
    return {
      svId: `svga-player-${svgaId++}` // 动态生成唯一ID
    };
  },
  mounted() {
    this.initPlayer();
  },
  beforeDestroy() {
    this.destroyPlayer(); // 组件销毁时释放资源
  },
  methods: {
    initPlayer() {
      try {
        const player = new SVGA.Player(`#${this.svId}`);
        player.loops = this.loops;
        player.clearsAfterStop = false;
        
        const parser = new SVGA.Parser(`#${this.svId}`);
        parser.load(this.src, (videoItem) => {
          player.setVideoItem(videoItem);
          player.setContentMode(this.mode);
          player.startAnimation();
          
          // 回调函数
          player.onFinished(() => this.$emit("finished", this.onlyTag));
          player.onFrame((frame) => this.$emit("onFrame", frame, this.onlyTag));
        });
        
        this.player = player; // 保存实例以便销毁
      } catch (error) {
        console.error("SVGA初始化失败:", error);
      }
    },
    destroyPlayer() {
      if (this.player) {
        this.player.stopAnimation();
        this.player = null;
      }
    }
  }
};
</script>